import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import StyledMenu from "../../../../components/layout/StyledMenu";
import {
  Backdrop,
  Box,
  Button,
  ButtonGroup,
  Card,
  CardActionArea,
  Chip,
  Container,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  MenuItem,
  Modal,
  Switch,
  Typography
} from "@mui/material";
import {
  deleteData,
  findGetParameter,
  postData
} from "../../../../components/utilities/UtilityFunctions";
import { postNotification } from "../../../../components/utilities/Notifications";
import ExportModal from "../../../../components/modals/ExportModal";
import TopCutModal from "../TopCutModal";
import { handlePagingAll } from "../../../../components/api/APIUtilities";
import moment from "moment";
import "moment-timezone";
import {
  BCPAngleDown,
  BCPXmark
} from "../../../../components/icons/bcp/BCPIcons";
import ListResponsive from "../../../../components/other/ListResponsive";
import { getSearchProps } from "../../utils";
import { PlayerRow } from "../SubComponents/EventPlacingsRows";
import PlayerModal from "../PlayerModal";
import ModalLoadingFull from "../../../../components/modals/ModalLoadingFull";
import { useConfirm } from "material-ui-confirm";
import WebSocketIndicator from "../SubComponents/WebSocketIndicator";
import { removeLocalStorage } from "../../../../components/layout/cookies/CookieFunctions";

export default function EventPlacingsDefault(props) {
  const {
    event,
    playerType,
    setPlayerType,
    showOverall,
    setShowOverall,
    subLoading,
    setSubLoading,
    players,
    authContext,
    organize,
    loading,
    setLoading,
    setEvent,
    optionsAnchorEl,
    setOptionsAnchorEl,
    setPlayer,
    placingDict,
    league,
    player,
    playerDict,
    setRefreshPlayers,
    setResetModalOpen,
    placingsReady,
    socketStatus,
    handleWSConnection,
    handleLoad,
    setPTypeUpdating,
    useWebSockets
  } = props;

  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventPlacings"
  });
  const { t: tGeneral } = useTranslation();

  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      {/* <Alert
        icon={false}
        color="warning"
        sx={{ textAlign: "center", justifyContent: "center" }}
      >
        <AlertTitle sx={{ textTransform: "uppercase" }}>
          Submit to Circuits
        </AlertTitle>
        Your event has finished, and you have active circuit tokens that you
        have not submtted your results to.
      </Alert> */}

      <Grid container sx={{ gap: 2 }}>
        {event?.teamEvent && (
          <Grid
            item
            xs={12}
            sx={{
              p: 2
            }}
          >
            <ButtonGroup fullWidth>
              <Button
                variant={
                  playerType === "teamplayers" ? "contained" : "outlined"
                }
                color="primary"
                onClick={() => {
                  if (playerType !== "teamplayers") {
                    if (setPTypeUpdating) setPTypeUpdating(true);
                    setPlayerType("teamplayers");
                  }
                }}
              >
                {t("teamPlacings")}
              </Button>
              <Button
                variant={playerType === "players" ? "contained" : "outlined"}
                color="primary"
                onClick={() => {
                  if (playerType !== "players") {
                    if (setPTypeUpdating) setPTypeUpdating(true);
                    setPlayerType("players");
                  }
                }}
              >
                {t("playersPlacings")}
              </Button>
            </ButtonGroup>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sx={{
            p: 2
          }}
        >
          {(organize ||
            event?.displayOverall === true ||
            event?.flags?.displayOverall === true) &&
          event?.numberOfRounds > 0 ? (
            <Box style={{ textAlign: "right", width: "100%" }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOverall}
                    onChange={() => {
                      setSubLoading(true);
                      setShowOverall(!showOverall);
                      setSubLoading(false);
                    }}
                  />
                }
                label={
                  showOverall
                    ? t("hideOverallPlacings")
                    : t("showOverallPlacings")
                }
              />
            </Box>
          ) : (
            <></>
          )}

          {useWebSockets && socketStatus && (
            <Grid item xs={12}>
              <WebSocketIndicator
                status={socketStatus}
                label
                onClick={async () => {
                  if (socketStatus === "Disconnected") {
                    try {
                      setLoading(true);
                      await handleLoad(playerType);
                      await handleWSConnection();
                    } catch (err) {
                      postNotification("error", err);
                    } finally {
                      setLoading(false);
                    }
                  }
                }}
              />
            </Grid>
          )}

          <ListResponsive
            originalList={
              subLoading
                ? null
                : showOverall
                  ? players?.filter(function (el) {
                      return !el?.isPod;
                    })
                  : players
            }
            doSearch
            doPages
            rowsPerPageArray={[16, 32, 48, 64, 96, { label: "All", value: -1 }]}
            initialRowsPerPage={32}
            userRowsPerPage="placings"
            authContext={authContext}
            actionButton={
              organize
                ? [
                    {
                      props: {
                        variant: "contained",
                        color: "primary",
                        onClick: async (e) => {
                          setLoading(true);
                          try {
                            var apiEvent = await postData(
                              `/events/${event.id}`,
                              {
                                body: {
                                  set: {
                                    hidePlacings: !event.hidePlacings
                                  }
                                }
                              }
                            );
                            setEvent({ ...event, ...apiEvent });
                            postNotification(
                              "success",
                              tGeneral("notifications.success.eventUpdated")
                            );
                          } catch (err) {
                            postNotification("error", err);
                          }
                          setLoading(false);
                        }
                      },
                      label: event.hidePlacings
                        ? t("unhidePlacings")
                        : t("hidePlacings")
                    },
                    {
                      props: {
                        variant: "outlined",
                        color: "primary",
                        fullWidth: true,
                        "aria-expanded": Boolean(optionsAnchorEl)
                          ? true
                          : undefined,
                        onClick: (e) => {
                          setOptionsAnchorEl(e.currentTarget);
                        },
                        endIcon: <BCPAngleDown />
                      },
                      label: t("options")
                    }
                  ]
                : null
            }
            searchProps={getSearchProps(
              playerType === "teamplayers" ? true : false,
              t
            )}
            rowProps={{
              mapFunction: (row, index) => (
                <PlayerRow
                  key={row.id}
                  organize={organize}
                  row={row}
                  setPlayer={setPlayer}
                  showOverall={showOverall}
                  placingDict={placingDict}
                  event={event}
                  league={league}
                />
              )
            }}
          />
        </Grid>
      </Grid>
      {players && players?.length && !subLoading ? (
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <Typography variant="caption">
            {placingsReady ? t("placingsUpToDate") : t("placingsUpdating")}
          </Typography>
        </Grid>
      ) : (
        <></>
      )}

      <PlayerModal
        isTeam={playerType === "teamplayers"}
        player={player}
        setPlayer={setPlayer}
        playerDict={playerDict}
        event={event}
        authContext={authContext}
        organize={organize}
        setRefreshPlayers={setRefreshPlayers}
        playerType={playerType}
        showOverall={showOverall}
      />
      {organize && (
        <>
          <OptionsMenu
            anchorEl={optionsAnchorEl}
            setAnchorEl={setOptionsAnchorEl}
            setLoading={setLoading}
            event={event}
            setEvent={setEvent}
            authContext={authContext}
            setRefreshPlayers={setRefreshPlayers}
            setResetModalOpen={setResetModalOpen}
            tGeneral={tGeneral}
          />
        </>
      )}
      {loading && <ModalLoadingFull />}
    </Container>
  );
}

function OptionsMenu(props) {
  const {
    anchorEl,
    setAnchorEl,
    setLoading,
    setRefreshPlayers,
    event,
    setEvent,
    authContext,
    setResetModalOpen,
    tGeneral
  } = props;
  const [rosterModal, setRosterModal] = useState(false);
  const [submitOpen, setSubmitOpen] = useState(false);

  const [topCutOptions, setTopCutOptions] = useState(null);

  const [exportTypes, setExportTypes] = useState(["placings"]);

  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventPlacings"
  });

  const open = Boolean(anchorEl);
  return (
    <>
      <StyledMenu
        id="options-menu"
        MenuListProps={{
          "aria-labelledby": "options-button"
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={async (e) => {
            setLoading(true);

            try {
              await postData(`/events/${event.id}/updatePlacings`);

              setRefreshPlayers(true);
            } catch (err) {
              postNotification("error", err);
            }

            removeLocalStorage("placings");
            removeLocalStorage("placingsData");

            setLoading(false);
            setAnchorEl(null);
          }}
          disableRipple
        >
          {t("refreshPlacings")}
        </MenuItem>
        <MenuItem
          onClick={async (e) => {
            setLoading(true);
            try {
              var apiEvent = await postData(`/events/${event.id}`, {
                body: {
                  set: {
                    displayOverall: !event.displayOverall
                  }
                }
              });
              setEvent({ ...event, ...apiEvent });
              postNotification(
                "success",
                tGeneral("notifications.success.eventUpdated")
              );
            } catch (err) {
              postNotification("error", err);
            }
            setLoading(false);
          }}
          disableRipple
        >
          {event.displayOverall === true
            ? t("hideOverallPlacingsFromPlayers")
            : t("showOverallPlacingsToPlayers")}
        </MenuItem>
        <MenuItem
          onClick={async () => {
            setTopCutOptions(event);
            setAnchorEl(null);
          }}
          disableRipple
        >
          {t("topCut")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRosterModal(true);
            setAnchorEl(null);
            setExportTypes(["placings"]);
          }}
          disableRipple
        >
          {t("exportPlacings")}
        </MenuItem>
        {event?.gameSystem?.code === 8 && (
          <MenuItem
            onClick={() => {
              setRosterModal(true);
              setAnchorEl(null);
              setExportTypes(["nafBloodbowl"]);
            }}
            disableRipple
          >
            {t("nafExport")}
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            setSubmitOpen(true);
            setAnchorEl(null);
          }}
          disableRipple
        >
          {t("submitToCircuit")}
        </MenuItem>
        <MenuItem
          onClick={async (e) => {
            setLoading(true);

            try {
              await deleteData(`/events/${event.id}/clearCache`);
              setRefreshPlayers(true);
              postNotification(
                "success",
                tGeneral("notifications.success.eventCacheCleared")
              );
            } catch (err) {
              postNotification("error", err);
            }

            setLoading(false);
            setAnchorEl(null);
          }}
          disableRipple
        >
          {t("clearEventCache")}
        </MenuItem>

        <Divider
          sx={{
            mt: 2,
            mb: 2
          }}
        />
        <MenuItem
          onClick={async (e) => {
            setResetModalOpen(true);
            setAnchorEl(null);
          }}
          disableRipple
          sx={{ color: "error.main" }}
        >
          {t("resetTo")}
        </MenuItem>
      </StyledMenu>
      <ExportModal
        label={
          exportTypes?.[0] === "nafBloodbowl"
            ? t("nafExport")
            : t("exportPlacings")
        }
        exportTypes={exportTypes}
        event={event}
        setLoading={setLoading}
        open={rosterModal}
        setOpen={setRosterModal}
        authContext={authContext}
      />
      <SubmitModal
        event={event}
        setLoading={setLoading}
        open={submitOpen}
        setOpen={setSubmitOpen}
        authContext={authContext}
      />
      <TopCutModal
        open={topCutOptions}
        setOpen={setTopCutOptions}
        event={event}
        setEvent={setEvent}
        setLoading={setLoading}
        changeRound={() => {
          window.location.assign(
            `/organize/event/${event.id}?active_tab=pairings`
          );
        }}
      />
    </>
  );
}

function SubmitModal(props) {
  const { event, open, setOpen, setLoading, authContext } = props;
  const [leagues, setLeagues] = useState(null);
  const [storeLeagues, setStoreLeagues] = useState(null);
  const [leagueTokens, setLeagueTokens] = useState(null);
  const embed = props?.appRoute || findGetParameter("embed") === "true";
  const confirm = useConfirm();

  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventPlacings.submitModal"
  });

  const submitToLeague = async (leagueId, tokenCode) => {
    try {
      setLoading(true);
      var body = {
        leagueId: leagueId
      };
      if (tokenCode) {
        body.tokenCode = tokenCode;
      }
      await postData(`/events/${event.id}/submitToLeague`, {
        body: body
      });
      var tempLeagues = [];
      if (tokenCode) {
        leagues.forEach((league) => {
          if (league.id !== leagueId) {
            tempLeagues.push(league);
          }
        });
        setLeagues(tempLeagues?.length ? tempLeagues : null);
      } else {
        storeLeagues.forEach((league) => {
          tempLeagues.push({
            ...league,
            submitted: league.submitted || league.id === leagueId
          });
        });
        setStoreLeagues(tempLeagues?.length ? tempLeagues : null);
      }
    } catch (err) {
      postNotification("error", err);
    }
    setLoading(false);
  };

  const fetch = async () => {
    setLeagues(null);
    var leagueDict = {};
    var tempLeagues = [];
    var tempStoreLeagues = [];

    var apiEventTokens = await handlePagingAll("/leaguetokens", {
      eventId: event?.id,
      "expand[]": ["league"]
    });

    if (apiEventTokens) {
      apiEventTokens.sort((a, b) => {
        return moment(b.updated_at).diff(moment(a.updated_at));
      });

      setLeagueTokens(apiEventTokens);

      apiEventTokens.forEach((apiEventToken) => {
        if (
          !leagueDict[apiEventToken.leagueId] &&
          (apiEventToken.status === "active" ||
            apiEventToken.status === "pending")
        ) {
          tempLeagues.push({
            ...apiEventToken.league,
            token: {
              id: apiEventToken.id,
              code: apiEventToken.code,
              status: apiEventToken.status
            }
          });
          leagueDict[apiEventToken.leagueId] = true;
        }
      });

      tempLeagues.sort((a, b) => {
        var nameA = a.name.toLowerCase();
        var nameB = b.name.toLowerCase();
        if (nameA > nameB) return 1;
        if (nameA < nameB) return -1;
        return 0;
      });
    }

    setLeagues(tempLeagues);

    if (event?.gameStoreId !== undefined) {
      var apiStoreLeagues = await handlePagingAll("/leagues", {
        gameStoreId: event?.gameStoreId,
        gameSystemId: event?.gameSystemId,
        active: true
      });
      apiStoreLeagues.forEach((apiStoreLeague) => {
        if (!leagueDict[apiStoreLeague.id]) {
          leagueDict[apiStoreLeague.id] = true;
          tempStoreLeagues.push(apiStoreLeague);
        }
      });

      tempStoreLeagues.sort((a, b) => {
        var nameA = a.name.toLowerCase();
        var nameB = b.name.toLowerCase();
        if (nameA > nameB) return 1;
        if (nameA < nameB) return -1;
        return 0;
      });
    }

    setStoreLeagues(tempStoreLeagues);
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Modal
        disableAutoFocus
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
        sx={{ zIndex: 990 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: ["90vh", "95vh"],
            overflowY: "scroll",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setOpen(false);
            }}
          >
            <BCPXmark />
          </IconButton>
          {authContext?.authState?.identity?.isAdmin !== true &&
            !event?.userRole?.permissions?.circuitSubmission && (
              <Grid container spacing={1} sx={{ mt: 1 }}>
                <Grid item xs={12}>
                  <Typography variant="body1" paragraph>
                    {t("noAccessRole")}
                  </Typography>
                </Grid>
              </Grid>
            )}
          {!event?.ended ? (
            <Grid container spacing={1} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <Typography variant="body1" paragraph>
                  {t("endEventFirst")}
                </Typography>
                <Typography variant="body1" paragraph>
                  {t("findInPairings")}{" "}
                  <Link
                    href={`/organize/event/${event?.id}?active_tab=pairings${
                      embed ? "&embed=true" : ""
                    }`}
                    underline="none"
                  >
                    {t("pairings")}
                  </Link>
                  .
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <>
              {leagueTokens?.length > 0 && (
                <Grid container spacing={1} sx={{ mt: 1 }}>
                  <Grid item xs={12}>
                    <Typography variant="body1" sx={{ fontWeight: "600" }}>
                      {t("circuitTokens")}
                    </Typography>
                  </Grid>

                  {leagueTokens.map((token, index) => (
                    <Grid item xs={12}>
                      <Card key={index} sx={{ mt: 2 }}>
                        <CardActionArea
                          onClick={async (e) => {
                            if (token?.status === "active") {
                              try {
                                await confirm({
                                  title: t("submitEvent"),
                                  description: t("areYouSureSubmit", {
                                    eventName: event?.name || t("thisEvent"),
                                    circuitName:
                                      token?.league?.name || t("thisCircuit")
                                  }),
                                  dialogProps: {
                                    sx: {
                                      zIndex: 99999
                                    }
                                  }
                                });

                                try {
                                  setLoading(true);
                                  await submitToLeague(
                                    token?.league?.id,
                                    token?.code
                                  );
                                } catch (err) {
                                  postNotification("error", err);
                                } finally {
                                  setLoading(false);
                                }
                              } catch (err) {
                                return;
                              }
                            } else {
                              postNotification(
                                "warning",
                                t("tokenStillPending", {
                                  status:
                                    token?.status === "pending"
                                      ? t("pendingApproval")
                                      : token?.status
                                })
                              );
                            }
                          }}
                          sx={{ p: 1 }}
                        >
                          <Box sx={{ width: "100%" }}>
                            <Grid container spacing={1}>
                              <Grid item xs={12} sm={8} lg={9}>
                                <Typography variant="body1" fontWeight="700">
                                  {token?.league?.name || "-----"}
                                </Typography>
                                <Typography variant="body1">
                                  {t("token")}
                                  {`${
                                    token.tokenType
                                      ? ` (${token.tokenType}): ${token.code}`
                                      : `: ${token.code}`
                                  }`}
                                </Typography>
                                <Typography variant="caption">{`${
                                  token.userId
                                    ? `${token?.firstName} ${token?.lastName}`.trim() +
                                      ": "
                                    : ""
                                }${token.email}`}</Typography>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                lg={3}
                                sx={{ textAlign: ["left", "right"] }}
                              >
                                <Chip
                                  label={token.status.toUpperCase()}
                                  size="small"
                                  sx={{ width: "100%", mb: [1, 0] }}
                                  color={
                                    token.status.toLowerCase() === "active" ||
                                    token.status.toLowerCase() === "used"
                                      ? "success"
                                      : token.status.toLowerCase() === "pending"
                                        ? "warning"
                                        : "error"
                                  }
                                />
                                <Typography variant="caption">
                                  {t("requested")}:{" "}
                                  {moment(token.created_at).format("llll")}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        </CardActionArea>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}

              {storeLeagues?.length > 0 && (
                <Grid container spacing={1} sx={{ mt: 1 }}>
                  <Grid item xs={12}>
                    <Typography variant="body1" sx={{ fontWeight: "600" }}>
                      {event?.gameStore?.name} {t("circuits")}
                    </Typography>
                  </Grid>
                  {storeLeagues.map((league, index) => {
                    return (
                      <Grid key={index} item xs={12}>
                        <Button
                          variant="outlined"
                          fullWidth
                          color={league.submitted ? "success" : "primary"}
                          disabled={
                            !event?.ended ||
                            !event?.userRole?.permissions?.circuitSubmission
                          }
                          sx={{ textTransform: "unset" }}
                          onClick={async (e) => {
                            await submitToLeague(league.id, league.token?.code);
                          }}
                        >
                          {league.name}
                        </Button>
                      </Grid>
                    );
                  })}
                </Grid>
              )}

              {!leagueTokens?.length && !storeLeagues?.length && (
                <Grid container spacing={1} sx={{ mt: 1 }}>
                  <Grid item xs={12}>
                    <Typography variant="body1" paragraph>
                      {t("noCircuitTokens")}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Box>
      </Modal>
    </>
  );
}
